// extracted by mini-css-extract-plugin
module.exports = {"verifiedOld":"verified-badge_verifiedOld__uA1IV","verifiedBlue":"verified-badge_verifiedBlue__LVc8w","verifiedGovernment":"verified-badge_verifiedGovernment__avXHl"};